import { LoadingIcon } from '@/primer/components';
import type { LoadingIconProps } from '@/primer/components';

export interface PageLoadingStateProps {
  size?: LoadingIconProps['size'];
  label?: string;
}

export function PageLoadingState({ size = 'xl', label = 'Loading' }: PageLoadingStateProps) {
  return (
    <div className="fixed inset-0 flex items-center justify-center">
      <LoadingIcon size={size} aria-label={label} />
    </div>
  );
}

export default PageLoadingState;
